export class TicketStatus {
    static UNAVAILABLE = 'Unavailable';
    static NEW = 'New';
    static READY = 'Ready';
    static WAITING_FOR_TOOLS = 'WaitingForTools';
    static IN_PROGRESS = 'InProgress';
    static CLOSED = 'Closed';
    static DELETED = 'DELETED';
    static ON_HOLD = "OnHold";
}
